export default __webpack_public_path__ + "static/media/ownMyData.f717edbc.webp";